// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import find from 'lodash/find'
import { i18n } from '../index'
import FormLabel from '@mui/material/FormLabel'
import withActiveStation from '../station/withActiveStation'
import Select from '../../common/select/Select'
import { EditableConsumer } from '../../common/context/EditableContext'
import { usersToOptions } from '../../common/utils'
import type { User } from '../admin/users/userTypes'
import type { Station } from '../station/stationTypes'
import type { ShiftName, ShiftManager as ShiftManagerType } from './dailyManagementTypes'
import css from './shiftManagers.css'

const getUserIdForShift = (shiftName: ShiftName, data: Array<ShiftManagerType>): string | null | undefined =>
  data.filter((value) => value.shift === shiftName).map((value) => value.id)[0]

type ShiftManagerProps = {
  label: string
  value: string
  users: Array<User>
}

const ShiftManager = ({ label, value, users, ...inputProps }: ShiftManagerProps) => {
  const user = find(users, {
    id: value,
  })
  const userName = user ? `${user.name}` : null
  return (
    <EditableConsumer>
      {({ isEditable }) => (
        <div className={css.shiftManager}>
          <FormLabel className={css.formLabel}>{label}</FormLabel>
          {isEditable ? (
            <Select
              {...inputProps}
              className={css.select}
              placeholder={i18n.t('dailyManagement.label.shiftManagerPlaceholder')}
              value={value}
            />
          ) : (
            <p className={css.shiftManagerName}>{userName || i18n.t('dailyManagement.noShiftManager')}</p>
          )}
        </div>
      )}
    </EditableConsumer>
  )
}

type ShiftManagersProps = {
  activeStation: Station
  data: Array<ShiftManagerType>
  onChange: (...args: Array<any>) => any
}

@withActiveStation
class ShiftManagers extends React.PureComponent<ShiftManagersProps> {
  render() {
    const { activeStation, data, onChange } = this.props
    const users = activeStation.users || []
    const options = usersToOptions(users)
    return (
      <div className={css.component}>
        {['Morning', 'Evening', 'Night'].map((shiftName) => (
          <ShiftManager
            value={getUserIdForShift(shiftName as any, data)}
            label={i18n.t(`common.${shiftName.toLowerCase()}Shift`)}
            options={options}
            onChange={({ value }) => onChange(shiftName, value)}
            users={users}
            key={shiftName}
          />
        ))}
      </div>
    )
  }
}

export default ShiftManagers
